import { z } from 'zod'

export const agentNodeFormSchema = z.object({
  label: z
    .string()
    .min(1, 'Agent name is required')
    .max(100, 'Agent name must be at most 100 characters'),
  roleDescription: z.string().max(500, 'Role description must be at most 500 characters'),
  systemPrompt: z.string(),
  model: z.string().min(1, 'Model is required'),
  temperature: z.number().min(0).max(1),
  toolList: z.array(z.string()),
  imageUrl: z.string().optional(),
})

export type AgentNodeFormSchemaType = z.infer<typeof agentNodeFormSchema>

export const defaultAgentNodeFormValues: AgentNodeFormSchemaType = {
  label: '',
  roleDescription: '',
  systemPrompt: '',
  model: 'anthropic/claude-sonnet-4',
  temperature: 0.3,
  toolList: [],
  imageUrl: undefined,
}

export const edgeLabelSchema = z.object({
  label: z.string().max(50, 'Edge label must be at most 50 characters'),
})

export type EdgeLabelSchemaType = z.infer<typeof edgeLabelSchema>
